import { useEffect, useState, type ReactNode } from 'react';
import { authStorage } from '@/lib/auth';
import { isUserBanned, markUserBanned, subscribeBanned } from '@/lib/bannedSession';
import { useMe } from '@/hooks/useUser';
import { BannedPage } from '@/pages/BannedPage';

interface Props {
  children: ReactNode;
}

export const AuthGate = ({ children }: Props) => {
  const [banned, setBanned] = useState(isUserBanned());
  const hasToken = !!authStorage.getToken();

  const { data: me } = useMe({
    enabled: hasToken && !banned,
  });

  useEffect(() => subscribeBanned(() => setBanned(true)), []);

  useEffect(() => {
    if (me?.status === 'banned') {
      markUserBanned();
      setBanned(true);
    }
  }, [me?.status]);

  if (banned) {
    return <BannedPage />;
  }

  return children;
};
